import React from 'react';

export const OregonInfo = () => (
    <div>
        <p className="eds-text-bl eds-l-mar-bot-4">State of Oregon</p>
        <p className="eds-l-mar-bot-1">
            <strong>
                Loan programs and financial assistance for businesses,
                employers, and employees
            </strong>{' '}
            |&nbsp;
            <a
                href="http://www.oregon4biz.com/Coronavirus-Information/"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>
            Different loan programs and assistance with application process and
            forms can be accessed through Oregon&apos;s website.
        </p>

        <p className="eds-text-bl eds-l-mar-bot-4 eds-l-mar-top-8">
            City of Beaverton
        </p>
        <p className="eds-l-mar-bot-1">
            <strong>Beaverton Emergency Business Assistance Program</strong>{' '}
            |&nbsp;
            <a
                href="https://www.beavertonoregon.gov/EmergencyBizAssistance"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>
            Businesses that were ordered to close as a result of government
            coronavirus guidelines can apply for $2,500 per month in rent or
            mortgage reimbursement while the city is in a declared state of
            emergency.
        </p>

        <p className="eds-text-bl eds-l-mar-bot-4 eds-l-mar-top-8">
            City of Hillsboro
        </p>
        <p className="eds-l-mar-bot-1">
            <strong>Small Business Emergency Relief Program</strong> |&nbsp;
            <a
                href="https://www.hillsboro-oregon.gov/our-city/covid-19/business-resources"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>
            Qualified businesses are eligible to receive up to a $5,000 grant
            between March 23 and April 30, 2020.
        </p>

        <p className="eds-text-bl eds-l-mar-bot-4 eds-l-mar-top-8">
            Jade District-Old Town
        </p>
        <p className="eds-l-mar-bot-1">
            <strong>Small Business Response Fund</strong> |&nbsp;
            <a
                href="https://www.apano.org/jade-district-covid-19-small-business-response-fund/"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>
            Jade District Steering Committee voted to tap into their rainy day
            fund and contributed another $50,000 to be made accessible for all
            Jade District businesses. As such, up to $190,000 will be available
            for disbursement. These resources are intended to be an additional
            short-term tool to support local businesses and not in place of
            other government intervention to support Portland and Oregon’s
            broader economy.
        </p>
    </div>
);
